import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["id", "skills", "roles"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import flatten from 'lodash/flatten';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import { Model, referenceMany } from 'libx';
import { observable, computed } from 'mobx';
import { generateAvatarFallback } from '../utils/dummyImageUtil';
var Member = (_class = /*#__PURE__*/function (_Model) {
  function Member() {
    var _this;
    _classCallCheck(this, Member);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Member, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "givenName", _descriptor2, _this);
    _initializerDefineProperty(_this, "familyName", _descriptor3, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor4, _this);
    _initializerDefineProperty(_this, "userId", _descriptor5, _this);
    _initializerDefineProperty(_this, "displayName", _descriptor6, _this);
    _initializerDefineProperty(_this, "email", _descriptor7, _this);
    _initializerDefineProperty(_this, "phone", _descriptor8, _this);
    _initializerDefineProperty(_this, "picture", _descriptor9, _this);
    _initializerDefineProperty(_this, "inactive", _descriptor10, _this);
    _initializerDefineProperty(_this, "maxConcurrentProviderJobs", _descriptor11, _this);
    _initializerDefineProperty(_this, "approvedTermsVersion", _descriptor12, _this);
    _initializerDefineProperty(_this, "referrer", _descriptor13, _this);
    _initializerDefineProperty(_this, "memberPermissions", _descriptor14, _this);
    _initializerDefineProperty(_this, "computedPermissions", _descriptor15, _this);
    _initializerDefineProperty(_this, "notificationPreferences", _descriptor16, _this);
    _initializerDefineProperty(_this, "referrerMetadata", _descriptor17, _this);
    _initializerDefineProperty(_this, "memberMetadata", _descriptor18, _this);
    _initializerDefineProperty(_this, "workspaceMetadata", _descriptor19, _this);
    _initializerDefineProperty(_this, "roleIds", _descriptor20, _this);
    _initializerDefineProperty(_this, "skillIds", _descriptor21, _this);
    return _this;
  }
  _inherits(Member, _Model);
  return _createClass(Member, [{
    key: "workspace",
    get: function get() {
      return this.rootStore.workspaceStore.workspaces.get(this.workspaceId);
    }
  }, {
    key: "roles",
    get: function get() {
      return referenceMany(this.rootStore.roleStore.forWorkspace(this.workspaceId), this.roleIds, 'id');
    }
  }, {
    key: "skills",
    get: function get() {
      return referenceMany(this.rootStore.skillStore.forWorkspace(this.workspaceId), this.skillIds, 'id');
    }
  }, {
    key: "detailedDisplayName",
    get: function get() {
      var nameIsEmail = this.displayName === this.email;
      return "".concat(this.displayName, " (").concat(nameIsEmail ? '' : "email: ".concat(this.email, ", "), "id: ").concat(this.userId, ")");
    }
  }, {
    key: "avatar",
    get: function get() {
      // All Hail System Robot
      if (this.userId.endsWith('@clients') || this.userId.includes('SYSTEM_ROBOT')) {
        var _this$workspace, _this$workspace$brand;
        return (_this$workspace = this.workspace) === null || _this$workspace === void 0 ? void 0 : (_this$workspace$brand = _this$workspace.branding) === null || _this$workspace$brand === void 0 ? void 0 : _this$workspace$brand.system_robot.image;
      }
      return this.picture || this.avatarFallback;
    }
  }, {
    key: "avatarFallback",
    get: function get() {
      return generateAvatarFallback(this.displayName || this.email);
    }
  }, {
    key: "isCurrentUser",
    get: function get() {
      return this.userId === this.rootStore.sessionStore.user.userId;
    }
  }, {
    key: "online",
    get: function get() {
      var _this2 = this;
      return (this.rootStore.userStore.users.find(function (x) {
        return x.userId === _this2.userId;
      }) || {}).online;
    }
  }, {
    key: "hasAllPermissions",
    value: function hasAllPermissions() {
      var _this3 = this;
      for (var _len2 = arguments.length, ids = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        ids[_key2] = arguments[_key2];
      }
      ids = flatten(ids);
      if (ids.length === 0) return true;
      return ids.every(function (id) {
        return _this3.hasPermission(id);
      });
    }
  }, {
    key: "hasSomePermissions",
    value: function hasSomePermissions() {
      var _this4 = this;
      for (var _len3 = arguments.length, ids = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        ids[_key3] = arguments[_key3];
      }
      ids = flatten(ids);
      if (ids.length === 0) return true;
      return ids.some(function (id) {
        return _this4.hasPermission(id);
      });
    }
  }, {
    key: "hasPermission",
    value: function hasPermission(id) {
      var computedPerms = this.computedPermissions || {};
      return computedPerms[id] === 'allow' && this.rootStore.permissionStore.isFeatureEnabledForPermission(id);
    }
  }, {
    key: "parse",
    value: function parse(_ref) {
      var id = _ref.id,
        skills = _ref.skills,
        roles = _ref.roles,
        json = _objectWithoutProperties(_ref, _excluded);
      this.rootStore.userStore.users.set({
        user_id: json.user_id,
        public_id: json.user_public_id,
        email: json.email
      });
      var mapped = mapKeys(json, function (_, k) {
        return camelCase(k);
      });
      if (skills) {
        this.rootStore.skillStore.skills.set(skills.map(function (x) {
          return x.skill;
        }));
        mapped.skillIds = skills.map(function (x) {
          return x.skill.id;
        });
      }
      if (roles) {
        this.rootStore.roleStore.roles.set(roles.map(function (x) {
          return x.role;
        }));
        mapped.roleIds = roles.map(function (x) {
          return x.role.id;
        });
      }
      if (id && !this.id) {
        mapped.id = id;
      }
      return mapped;
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "givenName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "familyName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "displayName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "phone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "picture", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "inactive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "maxConcurrentProviderJobs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "approvedTermsVersion", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "referrer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "memberPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "computedPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "notificationPreferences", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "referrerMetadata", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "memberMetadata", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "workspaceMetadata", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "roleIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "skillIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "workspace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "workspace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "roles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "roles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skills", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "skills"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detailedDisplayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "detailedDisplayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "avatar", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "avatar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "avatarFallback", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "avatarFallback"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurrentUser", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurrentUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "online", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "online"), _class.prototype), _class);
export { Member as default };
//# sourceMappingURL=Member.js.map
